import React from 'react';
import { motion } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

export default function SecurityPage() {
    return (
        <div style={{ background: 'var(--bg-page)', minHeight: '100vh', color: 'var(--text-primary)', padding: '120px 40px' }}>
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                <motion.h1
                    initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
                    style={{ fontSize: '48px', fontWeight: '600', marginBottom: '24px', letterSpacing: '-0.02em' }}
                >
                    Enterprise-Grade Security
                </motion.h1>
                <p style={{ fontSize: '20px', color: 'var(--text-secondary)', marginBottom: '60px', lineHeight: 1.6 }}>
                    Your data is your most valuable asset. That's why we've built the Oblique framework around the core principles of Tenant Isolation, Role-Based Access Control, and multi-layer encryption.
                </p>

                <div style={{ display: 'grid', gap: '24px' }}>
                    <div style={{ padding: '32px', background: 'var(--bg-surface)', borderRadius: '16px', border: '1px solid var(--border)' }}>
                        <ObliqueIcon name="shield" style={{ color: 'var(--success)', width: '32px', height: '32px', marginBottom: '16px' }} />
                        <h3 style={{ fontSize: '24px', fontWeight: '500', marginBottom: '12px' }}>Tenant Isolation</h3>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: 1.5 }}>Our database architecture enforces strict segregation at the collection level. User roles are keyed explicitly to organizational IDs, ensuring cross-tenant data leaks are physically impossible.</p>
                    </div>

                    <div style={{ padding: '32px', background: 'var(--bg-surface)', borderRadius: '16px', border: '1px solid var(--border)' }}>
                        <ObliqueIcon name="lock" style={{ color: 'var(--blue)', width: '32px', height: '32px', marginBottom: '16px' }} />
                        <h3 style={{ fontSize: '24px', fontWeight: '500', marginBottom: '12px' }}>Role-Based Access Control (RBAC)</h3>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: 1.5 }}>Granular permission limits mean Quality Analysts can't see Operational pipelines, and standard Agents can only view their own calls. Principle of Least Privilege is our standard.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
